import { render, staticRenderFns } from "./candidateSickness.vue?vue&type=template&id=f7fdf85a&"
import script from "./candidateSickness.vue?vue&type=script&lang=js&"
export * from "./candidateSickness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports